import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { LayerService } from '../../../../services/layer.service';
import { BaseComponent } from '../../../base.component';
var LayerOpacityEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerOpacityEditorComponent, _super);
    function LayerOpacityEditorComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.layerService = layerService;
        _this.opacity = 1;
        _this.defaultLayerOpacity = 1;
        _this.opacityMultiplier = 100;
        _this.applyChange = function () {
            var newOpacity = _this.opacity / _this.opacityMultiplier;
            if (_this.layer && newOpacity !== _this.layer.opacity) {
                _this.layer.opacity = newOpacity;
                window.dispatchEvent(new CustomEvent('symbolChange', { detail: _this.uniqueLayerId }));
            }
        };
        _this.cancel = function () {
            _this.uniqueLayerId = null;
            _this.layer = null;
        };
        return _this;
    }
    Object.defineProperty(LayerOpacityEditorComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        set: function (value) {
            this._uniqueLayerId = value;
            if (value) {
                this.getLayer();
            }
        },
        enumerable: true,
        configurable: true
    });
    LayerOpacityEditorComponent.prototype.getLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.layer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
                this.layer.opacity = this.layer.opacity ? this.layer.opacity : this.defaultLayerOpacity;
                this.opacity = this.layer.opacity * this.opacityMultiplier;
                return [2 /*return*/];
            });
        });
    };
    return LayerOpacityEditorComponent;
}(BaseComponent));
export { LayerOpacityEditorComponent };
